/*-----------------------------------------------------
   GLOBAL LOADER ICON
------------------------------------------------------ */
const loadIcon =
  '<div class="sk-fading-circle">' +
  '<div class="sk-circle1 sk-circle"></div>' +
  '<div class="sk-circle2 sk-circle"></div>' +
  '<div class="sk-circle3 sk-circle"></div>' +
  '<div class="sk-circle4 sk-circle"></div>' +
  '<div class="sk-circle5 sk-circle"></div>' +
  '<div class="sk-circle6 sk-circle"></div>' +
  '<div class="sk-circle7 sk-circle"></div>' +
  '<div class="sk-circle8 sk-circle"></div>' +
  '<div class="sk-circle9 sk-circle"></div>' +
  '<div class="sk-circle10 sk-circle"></div>' +
  '<div class="sk-circle11 sk-circle"></div>' +
  '<div class="sk-circle12 sk-circle"></div>' +
  "</div>";

/*-----------------------------------------------------
    LOADER ICON. Cover an element with a transparent overlay with a large loading icon.
------------------------------------------------------ */
export const createLoader = function (element, posTop = 0) {
  const loaderEl = document.createElement("div"); //Create loader div
  const loaderPadding = posTop > 0 ? "py-0" : "py-4";
  loaderEl.className = "loader-lg px-3 " + loaderPadding;
  loaderEl.innerHTML = loadIcon;
  if (!element.classList.contains("loading")) {
    element.classList.add("loading");
    element.appendChild(loaderEl); //Add loader to selected element
    loaderEl.querySelector(".sk-fading-circle").style.top = posTop + "px";
  }
};

/* Remove the loader when finished */
export const removeLoader = function (element) {
  const loaderEl = element.querySelector(".loader-lg");
  element.classList.remove("loading");
  if (loaderEl) {
    loaderEl.remove();
  }
};

/*-----------------------------------------------------
    SMALL LOADER ICON. Replace an existing icon or create a new small loader icon. Usefull for buttons.
------------------------------------------------------ */
/* Create loader icon */
export const createIconLoader = function (element, color = "light") {
  const loadingIcon = loadIcon;
  let iconElement = element.querySelector(".icon");

  //Check if iconElement already exists
  if (iconElement) {
    if (!iconElement.hasAttribute("data-icon")) {
      iconElement.setAttribute("data-icon", iconElement.innerHTML); //Set current icon html to data attribute, so we can reuse it later
    }
    iconElement.classList.add(`loader-${color}`);
    iconElement.innerHTML = loadingIcon; //Set the current icon to loading icon
  } else {
    iconElement = `<span class="icon loader-${color} mr-2">${loadingIcon}</span>`; //Create new icon element
    element.insertAdjacentHTML("afterbegin", iconElement); //Add icon to given parent element
  }
};

/* Remove loader icon */
export const removeIconLoader = function (element, destroy) {
  const iconEl = element.querySelector(".icon");
  const icon = iconEl.getAttribute("data-icon");

  if (destroy === true) {
    iconEl.remove(); //Remove the icon element if there wasn't a previous icon.
  } else {
    if (icon) {
      iconEl.innerHTML = icon; //Replace loading icon with original icon
    } else {
      iconEl.remove(); //Remove the icon element if there wasn't a previous icon.
    }
  }
};
